import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWho() {
  return <section className="py-24 px-4 bg-white" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <FadeIn className="text-center mb-16" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-serif text-brown" data-id="element-59">
            Para quién es / para quién no
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-60">
          {/* Is For You */}
          <FadeIn direction="right" className="bg-sage/5 p-8 md:p-10 rounded-3xl" data-id="element-61">
            <h3 className="text-2xl font-serif text-sage mb-8 flex items-center gap-3" data-id="element-62">
              <CheckCircle2 className="w-8 h-8" data-id="element-63" />
              Es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-64">
              {['Querés sentirte más liviana sin dietas extremas.', 'Necesitás un plan simple y repetible.', 'Tenés estrés y poco tiempo, y querés que el plan se adapte a tu realidad.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-65">
                  <div className="w-1.5 h-1.5 rounded-full bg-sage mt-2.5 flex-shrink-0" data-id="element-66" />
                  <span className="text-lg text-brown-light leading-relaxed" data-id="element-67">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>

          {/* Is Not For You */}
          <FadeIn direction="left" className="bg-rose/5 p-8 md:p-10 rounded-3xl" data-id="element-68">
            <h3 className="text-2xl font-serif text-rose mb-8 flex items-center gap-3" data-id="element-69">
              <XCircle className="w-8 h-8" data-id="element-70" />
              No es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-71">
              {['Buscás diagnóstico o tratamiento médico.', 'Tenés síntomas intensos o señales de alarma (en ese caso, consultá).', 'Querés “algo perfecto” y no estás dispuesta a hacer cambios por 7 días.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-72">
                  <div className="w-1.5 h-1.5 rounded-full bg-rose mt-2.5 flex-shrink-0" data-id="element-73" />
                  <span className="text-lg text-brown-light leading-relaxed" data-id="element-74">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}